export const PASSWORD_HINT = "Mínimo 8 caracteres, com letra e número";

export const passwordError = (p) =>
  (p || "").length < 8 || !/[A-Za-zÀ-ÿ]/.test(p) || !/\d/.test(p)
    ? "A senha precisa ter pelo menos 8 caracteres, com pelo menos uma letra e um número"
    : null;
